import axios from "axios";

// 活动列表
export function merchantJoinApi(data) {
  return axios.post('/aftersale/api/merchantJoin/add', data);
}
